tindie.navigation.category = (function(t, $) {
	var navigation = tindie.navigation.view,
		products = tindie.productUtils;
	var sendImpressions = function() {
		if (window.ga && ga.create) {
			ga("send", "event", "Category Page", "Send Product Impressions", {
				nonInteraction: true,
				transport: "beacon"
			});
		}
	};
	var CategoryPage = function() {
		var self = this;
		navigation.call(self);
		self.displayNotice = ko.observable();
		self.toggleText = ko.observable();
		if ($("#flea-market-notice").length > 0) {
			self.displayNotice($("#flea-market-notice").data("notice"));
		}
		self.categoryProducts = ko.observableArray();
		self.recentlyPurchased = ko.observableArray();
		self.recentlyAdded = ko.observableArray();
		self.relatedProducts = ko.observableArray();
		self.toggleNotice = function() {
			!self.displayNotice() ? self.showNotice() : self.hideNotice();
		};
		self.hideNotice = function() {
			self.toggleText("Show");
			$("#flea-market-notice").slideUp(600, function() {
				self.displayNotice(false);
			});
			$.get("/browse/notice/toggle/?display_notice=false");
		};
		self.showNotice = function() {
			self.toggleText("Hide");
			$("#flea-market-notice").slideDown(600, function() {
				self.displayNotice(true);
			});
			$.get("/browse/notice/toggle/?display_notice=true");
		};
		self.createProductCard = function() {
			return products.createProductCard("Category Products", self.categoryProducts);
		};
		self.createRecentlyPurchased = function() {
			return products.createProductCard("Category Recently Purchased", self.recentlyPurchased);
		};
		self.createRecentlyAdded = function() {
			return products.createProductCard("Category Recently Added", self.recentlyAdded);
		};
		self.createRelatedProducts = function() {
			return products.createProductCard("Category Related Products", self.relatedProducts);
		};
	};
	t.init = function() {
		var vm = new CategoryPage();
		ko.applyBindings(vm, document.body);
		window.addEventListener("beforeunload", sendImpressions, false);
		$(".show_more").on("click", function(ev) {
			$(".all_countries").removeClass("hide");
			$(this).addClass("hide");
		});
	};
	return t;
})(tindie.navigation.category || {}, jQuery);